import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';

// Selectors
// @ts-ignore
import { makeSelectContainerGroupValue } from 'services/containerGroups/selectors';

interface OwnProps {
    containerGroupId?: number;
    showAfterSeconds: number;
    children?: React.ReactElement | null;
}

interface ConnectedProps {
    lastRequestedAt: string;
    printingSubmittedAt: string;
    isComplete: boolean;
}

type Props = OwnProps & ConnectedProps;

export class ContainerGroupSubmittedTimeGateComponent extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const {
            printingSubmittedAt,
            isComplete,
            children,
            showAfterSeconds
        } = this.props;

        const submittedAt = new Date(printingSubmittedAt).getTime();
        const now = new Date().getTime();
        const deltaSeconds = (now - submittedAt) / 1000;

        if (!isComplete && deltaSeconds && deltaSeconds > showAfterSeconds) {
            return children || null;
        }

        return null;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    lastRequestedAt: makeSelectContainerGroupValue('lastRequestedAt'),
    printingSubmittedAt: makeSelectContainerGroupValue('printingSubmittedAt'),
    isComplete: makeSelectContainerGroupValue('isComplete')
});

export default connect(mapStateToProps)(
    ContainerGroupSubmittedTimeGateComponent
);
